import { css } from 'styled-components';
import { styles } from '../../../../styles/themes/style';

/**
 * The campaign screens' <select> look, in one place.
 *
 * Two of them were left with the browser's native control. That is where "the arrow is
 * too close to the outline" comes from — the native arrow is drawn hard against the
 * right edge and no amount of padding moves it — and it is also why those dropdowns did
 * not match the rest of the app: a native select is a different height, border and
 * typeface from every other field around it.
 *
 * `appearance: none` drops the native arrow and the chevron below replaces it, inset far
 * enough to breathe. Copied from the sending-window select in CampaignFormPage, which is
 * the look the rest of the product already uses; extracted here so the next screen that
 * needs a dropdown does not start a fourth variant.
 */
export const campaignSelectStyle = css`
  height: 36px; width: 100%; box-sizing: border-box;
  padding: 0 32px 0 12px;
  border: 1.5px solid #dde3ee; border-radius: 8px;
  background: ${styles.colors.white};
  font-family: NunitoSans; font-size: 13px; color: ${styles.colors.black600};
  outline: none; cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6' fill='none'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%23677084' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat; background-position: right 12px center;
  &:focus {
    border-color: ${styles.colors.primary600};
    box-shadow: 0 0 0 3px rgba(89, 100, 255, 0.08);
  }
  &:disabled { opacity: .6; cursor: default; }
`;

export default campaignSelectStyle;
